/* eslint-disable */
/**
 * Zoom y desplazamiento horizontal del gráfico de evolución.
 *
 * Los métodos operan sobre la instancia de PanelLogic y no mantienen estado global.
 */
const logic = {
  evoZoom(st, o) {
    const D = this.data,
      N = D.days.length,
      on = N > 1 && (st.sAxis !== 'jaula' || st.sMix),
      B = this._evoB || [],
      minWindow = Math.min(3, N);
    const z = st.sZoom && st.sZoom[0] >= 0 && st.sZoom[1] < N ? st.sZoom : [0, N - 1],
      zw = z[1] - z[0] + 1,
      dr = st.sDrag;
    const fr = e => {
      const r = e.currentTarget.getBoundingClientRect();
      return Math.max(0, Math.min(1, r.width ? (e.clientX - r.left) / r.width : 0));
    };
    const setZ = (a, w) => {
      if (!N) return;
      w = Math.max(minWindow, Math.min(N, Math.round(w)));
      a = Math.max(0, Math.min(N - w, Math.round(a)));
      this.setState({
        sZoom: w >= N ? null : [a, a + w - 1],
        sDrag: null
      });
    };
    const def = {
      mt: '0',
      pl: '0',
      bt: 'none',
      pt: '0',
      nc: '#b8c1ce',
      fw: 400,
      sw: "0.925926vh",
      sh: "0.277778vh",
      ring: 'none'
    };
    const axes = o.sYAxes && o.sYAxes.length ? o.sYAxes : [{
      name: '',
      short: '',
      c: '#5a667a',
      ticks: o.sYTicks || []
    }];
    const leftAxes = axes.filter((_, i) => i % 2 === 0).reverse();
    const rightAxes = axes.filter((_, i) => i % 2 === 1);
    const multiAxis = axes.length > 1;
    const leftWidth = multiAxis ? leftAxes.length * 58 : axes[0].short ? 58 : 40;
    const rightWidth = multiAxis ? Math.max(1, rightAxes.length) * 58 : 80;
    return {
      ...o,
      sYAxes: axes,
      sYAxesLeft: leftAxes,
      sYAxesRight: rightAxes,
      sGridCols: leftWidth / 19.2 + 'vw minmax(0,1fr) ' + rightWidth / 19.2 + 'vw',
      sMeasureX: (width, fontSize) => {
        const sAxisWidth = Math.round(width);
        const sAxisFont = Math.round(fontSize * 100) / 100;
        if (sAxisWidth > 0 && sAxisFont > 0
          && (this.state.sAxisWidth !== sAxisWidth || this.state.sAxisFont !== sAxisFont)) {
          this.setState({ sAxisWidth, sAxisFont });
        }
      },
      sTipRows: (o.sTipRows || []).map(r => ({
        ...def,
        ...r
      })),
      sTipColumns: (o.sTipColumns || []).map(col => ({
        ...col,
        rows: (col.rows || []).map(r => ({
          ...def,
          ...r
        }))
      })),
      sTipW: o.sTipW || 'auto',
      sMoveZ: e => {
        const p = this._epan;
        if (on && p && st.sZoom) {
          const dx = e.clientX - p.x,
            dd = Math.round(-dx / p.w * zw);
          if (Math.abs(dx) > 3) p.moved = true;
          if (p.moved && p.z0 + dd !== z[0]) setZ(p.z0 + dd, zw);
          if (p.moved) return;
        }
        o.sMove && o.sMove(e);
      },
      sLeaveZ: () => {
        this._epan = null;
        o.sLeave && o.sLeave();
      },
      tipStop: e => e.stopPropagation(),
      sDownZ: e => {
        if (!on || !st.sZoom || e.button != null && e.button !== 0) return;
        e.preventDefault();
        this._epan = {
          x: e.clientX,
          z0: z[0],
          w: Math.max(1, e.currentTarget.getBoundingClientRect().width),
          moved: false
        };
      },
      sUpZ: () => {
        const p = this._epan;
        this._epan = null;
        if (p && p.moved) this._zJust = true;
      },
      sWheelZ: e => {
        if (!on) return;
        if (e.preventDefault) e.preventDefault();
        const x = fr(e),
          m = z[0] + x * zw,
          w = Math.round(Math.max(minWindow, Math.min(N, zw * Math.exp(e.deltaY * 0.0018))));
        if (w === zw) return;
        setZ(m - x * w, w);
      },
      sCursor: on && st.sZoom ? 'grab' : on ? 'zoom-in' : 'crosshair',
      sClickZ: e => {
        if (this._zJust) {
          this._zJust = false;
          return;
        }
        o.sClick && o.sClick(e);
      },
      sSelD: dr ? 'block' : 'none',
      sSelL: dr ? (Math.min(dr[0], dr[1]) * 100).toFixed(2) + '%' : '0%',
      sSelW: dr ? (Math.abs(dr[1] - dr[0]) * 100).toFixed(2) + '%' : '0%'
    };
  }
};
export default logic;
